<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: { Carousel, Slide },
  data() {
    return {
      post: {},
    };
  },
  created() {
    
  },
  destroyed() {
    
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let trxID = urlParams.get('MERCHANT_TRANID');
    let agg = 'faspay'
    if(trxID) {
      const errID = urlParams.get('ERR_CODE');
      if (errID && errID !== '0') {
        this.$router.push("/")
      }
      trxID = trxID.split("-")[1]
    } else {
      agg = 'paypal'
      trxID = urlParams.get('token');
    }
    axios.get('/order/trx-id/'+agg+"/"+trxID)
    .then((resp) => {
      const data = resp.data.data
      this.post = data
    })
  },
  methods: {

  }
};
</script>

<style scoped>
    a {
      color: #0000ee;
      text-decoration: underline;
    }
    
    a:hover {
      color: #0000ee;
      text-decoration: underline;
    }
    
    @media (max-width: 480px) {
      #u_row_1 .v-row-background-color {
        background-color: #ffffff !important;
      }
      #u_row_1.v-row-background-color {
        background-color: #ffffff !important;
      }
      #u_content_image_1 .v-src-width {
        width: 5127px !important;
      }
      #u_content_image_1 .v-src-max-width {
        max-width: 46% !important;
      }
      #u_column_3 .v-col-background-color {
        background-color: #ffffff !important;
      }
      #u_column_3.v-col-background-color {
        background-color: #ffffff !important;
      }
      #u_content_image_2 .v-src-width {
        width: 512px !important;
      }
      #u_content_image_2 .v-src-max-width {
        max-width: 21% !important;
      }
      #u_content_heading_1 .v-font-size {
        font-size: 24px !important;
      }
      #u_content_text_3 a {
        color: #0000ee !important;
        text-decoration: underline !important;
      }
      #u_content_text_3 a:hover {
        color: #0000ee !important;
        background-color: underline !important;
      }
    }
    
    .u-row {
      display: flex;
      flex-wrap: nowrap;
      margin-left: 0;
      margin-right: 0;
    }
    
    .u-row .u-col {
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }
    
    .u-row .u-col.u-col-50 {
      flex: 0 0 50%;
      max-width: 50%;
    }
    
    .u-row .u-col.u-col-100 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    
    @media (max-width: 767px) {
      .u-row:not(.no-stack) {
        flex-wrap: wrap;
      }
      .u-row:not(.no-stack) .u-col {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
    
    body,
    html {
      padding: 0;
      margin: 0
    }
    
    html {
      box-sizing: border-box
    }
    
    *,
    :after,
    :before {
      box-sizing: inherit
    }
    
    html {
      font-size: 14px;
      -ms-overflow-style: scrollbar;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
    }
    
    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 1rem;
      line-height: 1.5;
      color: #373a3c;
      background-color: #fff
    }
    
    p {
      margin: 0
    }
    
    .error-field {
      -webkit-animation-name: shake;
      animation-name: shake;
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both
    }
    
    .error-field input,
    .error-field textarea {
      border-color: #a94442!important;
      color: #a94442!important
    }
    
    .field-error {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: 700;
      position: absolute;
      top: -20px;
      right: 10px
    }
    
    .field-error:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-top-color: #ebcccc;
      border-width: 5px;
      margin-left: -5px
    }
    
    .spinner {
      margin: 0 auto;
      width: 70px;
      text-align: center
    }
    
    .spinner>div {
      width: 12px;
      height: 12px;
      background-color: hsla(0, 0%, 100%, .5);
      margin: 0 2px;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both
    }
    
    .spinner .bounce1 {
      -webkit-animation-delay: -.32s;
      animation-delay: -.32s
    }
    
    .spinner .bounce2 {
      -webkit-animation-delay: -.16s;
      animation-delay: -.16s
    }
    
    @-webkit-keyframes sk-bouncedelay {
      0%,
      80%,
      to {
        -webkit-transform: scale(0)
      }
      40% {
        -webkit-transform: scale(1)
      }
    }
    
    @keyframes sk-bouncedelay {
      0%,
      80%,
      to {
        -webkit-transform: scale(0);
        transform: scale(0)
      }
      40% {
        -webkit-transform: scale(1);
        transform: scale(1)
      }
    }
    
    @-webkit-keyframes shake {
      0%,
      to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
      }
      10%,
      30%,
      50%,
      70%,
      90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0)
      }
      20%,
      40%,
      60%,
      80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0)
      }
    }
    
    @keyframes shake {
      0%,
      to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
      }
      10%,
      30%,
      50%,
      70%,
      90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0)
      }
      20%,
      40%,
      60%,
      80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0)
      }
    }
    
    @media only screen and (max-width:480px) {
      .container {
        max-width: 100%!important
      }
    }
    
    .container {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
      margin-right: auto;
      margin-left: auto
    }
    
    @media (min-width:576px) {
      .container {
        max-width: 540px
      }
    }
    
    @media (min-width:768px) {
      .container {
        max-width: 720px
      }
    }
    
    @media (min-width:992px) {
      .container {
        max-width: 960px
      }
    }
    
    @media (min-width:1200px) {
      .container {
        max-width: 1140px
      }
    }
</style>

<template>

  <div id="u_body" class="u_body" style="min-height: 100vh; background-color: #ffffff; font-family: arial,helvetica,sans-serif;">

    <div id="u_row_2" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_2" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_1" class="u_row v-row-background-color" style="padding: 17px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_1" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_image_1" class="u_content_image" style="overflow-wrap: break-word;padding: 10px;">

                <div style="position:relative;line-height:0px;text-align:center">

                  <img alt="Image" class="v-src-width v-src-max-width" src="https://s3.amazonaws.com/unroll-images-production/projects%2F12163%2F1620348130811-Main+Logo+%281%29.png" style="width: 33%;max-width: 33%;" title="Image" />

                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_3" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_3" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_image_2" class="u_content_image" style="overflow-wrap: break-word;padding: 10px;">

                <div style="position:relative;line-height:0px;text-align:center">

                  <img alt="Image" class="v-src-width v-src-max-width" src="https://s3.amazonaws.com/unroll-images-production/projects%2F12163%2F1613743666758-check.png" style="width: 16%;max-width: 16%;" title="Image" />

                </div>

              </div>

              <div id="u_content_heading_1" class="u_content_heading" style="overflow-wrap: break-word;padding: 0px;">

                <h1 class="v-font-size" style="margin: 0px; color: #14547e; line-height: 150%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: 'Montserrat',sans-serif; font-size: 43px;">
                  Payment Complete
                </h1>

              </div>

              <div id="u_content_text_1" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px; font-family: Montserrat, sans-serif;">Thank you, your payment has been succesful. A confirmation email has been sent to <strong>{{post.account_email}}</strong></span></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_7" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_7" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_6" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_6" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_heading_2" class="u_content_heading" style="overflow-wrap: break-word;padding: 19px 10px 0px;">

                <h1 class="v-font-size" style="margin: 0px; color: #ba372a; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: 'Montserrat',sans-serif; font-size: 15px;">
                  <strong>ORDER DETAILS</strong>
                </h1>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_5" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_5" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_divider_1" class="u_content_divider" style="overflow-wrap: break-word;padding: 10px;">
                <div style="text-align:center;line-height:0">
                  <div style="border-top-width:2px;border-top-style:solid;border-top-color:#95a5a6;width:100%;display:inline-block;line-height:2px;height:0px;vertical-align:middle"> </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_8" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_8" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_3" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: right; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: right;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;"><strong>ORDER REF</strong></span></p>
                </div>

              </div>

            </div>
          </div>

          <div id="u_column_9" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_5" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: left;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;">{{post.order_ref}}</span></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_10" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_11" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_6" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: right; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: right;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;"><strong>ORDER DATE</strong></span></p>
                </div>

              </div>

            </div>
          </div>

          <div id="u_column_12" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_7" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: left;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;">{{post.order_date}}</span></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_11" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_13" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_8" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: right; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: right;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;"><strong>PAYMENT TYPE</strong></span></p>
                </div>

              </div>
            </div>
          </div>

          <div id="u_column_14" class="u-col u-col-50 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_text_9" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: left;"><span style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 19.6px;">{{post.payment_type}}</span></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_4" class="u_row v-row-background-color" style="padding: 0px;">
      <div class="container" style="max-width: 500px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_4" class="u-col u-col-100 u_column">
            <div class="v-col-background-color" style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_divider_2" class="u_content_divider" style="overflow-wrap: break-word;padding: 10px;">
                <div style="text-align:center;line-height:0">
                  <div style="border-top-width:2px;border-top-style:solid;border-top-color:#95a5a6;width:100%;display:inline-block;line-height:2px;height:0px;vertical-align:middle"> </div>
                </div>
              </div>

              <div id="u_content_text_2" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%; text-align: center;"><a href="/" target="_self">Back to Home Page</a></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>